import { createContext, useContext, useEffect, useState } from "react";
import { en } from "./translations/en";
import { ja } from "./translations/ja";
import { pl } from "./translations/pl";
import { enX } from "./translations/en_extra";
import { jaX } from "./translations/ja_extra";
import { plX } from "./translations/pl_extra";

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "ja", label: "JA", name: "日本語" },
  { code: "pl", label: "PL", name: "Polski" },
];

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);
const merge = (base, over) => {
  if (Array.isArray(base) || Array.isArray(over)) return over ?? base;
  if (isObj(base) && isObj(over)) {
    const out = { ...base };
    for (const k of Object.keys(over)) out[k] = k in base ? merge(base[k], over[k]) : over[k];
    return out;
  }
  return over ?? base;
};

const DICTS = {
  en: merge(en, enX),
  ja: merge(ja, jaX),
  pl: merge(pl, plX),
};

const LangContext = createContext({ lang: "en", setLang: () => {}, d: DICTS.en });
export const useI18n = () => useContext(LangContext);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("wra-lang") || "en");
  useEffect(() => {
    localStorage.setItem("wra-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const d = merge(DICTS.en, DICTS[lang]);
  return <LangContext.Provider value={{ lang, setLang, d }}>{children}</LangContext.Provider>;
}
